module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "users-permissions"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('div', [
    [_c('b-breadcrumb', {
      staticClass: "breadCrumb",
      attrs: {
        "items": _vm.breadCrumbItems
      }
    })]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-tabs', {
    ref: "tabs",
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Administration"
    }
  }, [_c('div', {
    staticClass: " wrap-tab-item text-left"
  }, [_c('b-table', {
    attrs: {
      "items": _vm.usersList.filter(function (obj) { return obj.role && obj.role != 'basic'; }),
      "fields": _vm.fieldsAdmin,
      "filter": _vm.filter,
      "hover": ""
    },
    on: {
      "row-clicked": _vm.onAdminRowClick
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(data) {
        return [_vm._v("\n                  " + _vm._s(data.index + 1) + "\n                ")]
      }
    }, {
      key: "first_name",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }, {
      key: "last_name",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }, {
      key: "role_display",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }, {
      key: "areas",
      fn: function(item) {
        return _vm._l((_vm.getUserArea(item.value)), function(area) {
          return _c('p', [_vm._v(_vm._s(area))])
        })
      }
    }, {
      key: "upn",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }])
  })], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Basic users"
    }
  }, [_c('div', {
    staticClass: " wrap-tab-item text-left"
  }, [_c('b-table', {
    attrs: {
      "items": _vm.usersList.filter(function (obj) { return obj.role == 'basic'; }),
      "fields": _vm.fieldsBasic,
      "filter": _vm.filter,
      "hover": ""
    },
    on: {
      "row-clicked": _vm.onBasicRowClick
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(data) {
        return [_vm._v("\n                  " + _vm._s(data.index + 1) + "\n                ")]
      }
    }, {
      key: "first_name",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }, {
      key: "last_name",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }, {
      key: "areas",
      fn: function(item) {
        return _vm._l((_vm.getUserArea(item.value)), function(area) {
          return _c('p', [_vm._v(_vm._s(area))])
        })
      }
    }, {
      key: "upn",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }])
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [(_vm.tabIndex == 0) ? _c('b-button', {
    staticClass: "add-btn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAddAdminClick()
      }
    }
  }, [_vm._v("\n            Add administrator\n          ")]) : _vm._e(), _vm._v(" "), (_vm.tabIndex == 1) ? _c('b-button', {
    staticClass: "add-btn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAddUserClick()
      }
    }
  }, [_vm._v("\n            Add basic user\n          ")]) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "horizontal": "",
      "label": "",
      "label-cols": 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "debounce",
      rawName: "v-debounce",
      value: (500),
      expression: "500"
    }],
    attrs: {
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  })])], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-475de30e","hasScoped":true}!./src/components/usersPermissions/usersPermissions.component.html
// module id = 542
// module chunks = 1